import AxiosControl from '../../context/axios/AxiosControl'
const Axios = AxiosControl()

export const getSeasonsByClub = (club) => async (dispatch) => {
    dispatch({
        type: 'SEASON_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/season/getSeasonsByClub/'+ club, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SEASON_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SEASON_NOT_LOADING'
        })
    }
}

export const getSeason = (seasonId) => async (dispatch) => {
    dispatch({
        type: 'SEASON_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/season/getSeason/'+ seasonId, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SEASON_GET_SUCCESS',
                payload: data?.season
            })
        }
    } catch (error) {
        dispatch({
            type: 'SEASON_NOT_LOADING'
        })
    }
}

export const getSeasonsPublicForFilter = () => async (dispatch) => {
    dispatch({
        type: 'SEASON_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/season/public/getpublicseasonsforfilter/')

        if (status === 200) {
            dispatch({
                type: 'SEASON_GETALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'SEASON_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'SEASON_NOT_LOADING'
        })
    }
}

export const addSeason = (seasondata) => async (dispatch) => {
    dispatch({
        type: 'SEASON_LOADING'
    })
    try {
        const { data, status} = await Axios.post('/api/season/register', seasondata, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'SEASON_ADD_SUCCESS',
                payload: data?.message
            })
        }
    } catch (error) {
        dispatch({
            type: 'SEASON_NOT_LOADING'
        })
    }
}

export const editSeason = (seasonId, seasonData) => async (dispatch) => {
    dispatch({
        type: 'SEASON_LOADING'
    })
    try {
        const { data, status} = await Axios.post('/api/season/edit/' + seasonId, seasonData, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'SEASON_ADD_SUCCESS',
                payload: data?.message
            })
        }
    } catch (error) {
        dispatch({
            type: 'SEASON_NOT_LOADING'
        })
    }
}